module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/MATTRZ_CX_ZERO-4b9fdedd2402acf19215f907531fdb0e.svg";